import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiAlertError } from '@core/decorators/api-alert-error';
import { Cgu, CguJson } from '@models/cgu.model';

export const CGU_DOCUMENT_TYPE = 'terms_of_service';
export const GDPR_DOCUMENT_TYPE = 'gdpr';

@Injectable({ providedIn: 'root' })
export class CguApiService {
  private readonly http = inject(HttpClient);

  @ApiAlertError()
  signedDocumentAgreements(): Observable<Cgu[]> {
    return this.http
      .get<CguJson[]>('api/v1/users/me/signed_document_agreements?applications=legal')
      .pipe(map((cgus: CguJson[]) => cgus.map(cgu => Cgu.fromJson(cgu))));
  }

  @ApiAlertError()
  unsignedDocumentAgreements(types?: string): Observable<Cgu[]> {
    return this.http
      .get<CguJson[]>('api/v1/users/me/unsigned_agreement_documents', {
        params: { applications: 'legal', ...(types && { types }) }
      })
      .pipe(map((cgus: CguJson[]) => (cgus ?? []).map(cgu => Cgu.fromJson(cgu))));
  }

  @ApiAlertError()
  signDocuments(documens: string[]): Observable<unknown> {
    return this.http.post('api/v1/users/me/document_agreements', { file_uuids: documens, application_source: 'legal' });
  }

  @ApiAlertError()
  downloadDocument(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' }).pipe(map(res => new Blob([res], { type: 'application/pdf' })));
  }
}
